import { Triangle, ArrowUp, Layers, Target } from 'lucide-react';

interface ItemInputProps {
  northStar?: string;
  onNorthStarChange?: (northStar: string) => void;
  onStart: () => void;
}

export function ItemInput({ onStart }: ItemInputProps) {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-[var(--bg-raised)] shadow-sm border border-[var(--rule)] p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-[var(--slate-dim)]">
            <Triangle className="h-6 w-6 text-[var(--text-ter)]" />
          </div>
          <h2 className="text-2xl font-bold text-[var(--text-pri)]">
            Max Priorities Pyramid
          </h2>
        </div>
        
        <p className="text-[var(--text-sec)] mb-6">
          A powerful framework for visualizing the relationship among priorities that span across time and categories.
        </p>

        {/* Pyramid Concept Overview */}
        <div className="bg-gradient-to-b from-indigo-50 to-blue-50 p-4 mb-6">
          <h3 className="font-medium text-[var(--text-pri)] mb-3">How the pyramid works:</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[var(--slate-dim)] flex items-center justify-center">
                <ArrowUp className="h-3.5 w-3.5 text-[var(--text-ter)]" />
              </div>
              <div>
                <span className="font-medium text-[var(--text-pri)]">Create the Future</span>
                <span className="text-[var(--text-sec)]"> — Long-term strategic priorities at the top</span>
                <span className="block text-xs text-[var(--text-ter)] mt-0.5">
                  Items at the very top represent your North Star
                </span>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[var(--mustard-dim)] flex items-center justify-center">
                <Layers className="h-3.5 w-3.5 text-[var(--mustard)]" />
              </div>
              <div>
                <span className="font-medium text-[var(--text-pri)]">Reinforce Foundation</span>
                <span className="text-[var(--text-sec)]"> — Connecting layer bridging now and future</span>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[var(--green-dim)] flex items-center justify-center">
                <Target className="h-3.5 w-3.5 text-[var(--green)]" />
              </div>
              <div>
                <span className="font-medium text-[var(--text-pri)]">Get House in Order</span>
                <span className="text-[var(--text-sec)]"> — Near-term and immediate priorities at the base</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Strategic Themes Explanation */}
        <div className="text-sm text-[var(--text-sec)] mb-6 p-4 bg-[var(--surface)]">
          <span className="font-medium text-[var(--text-pri)]">Strategic Themes (columns):</span>{' '}
          Organize priorities into categories that matter to your organization—like Process Automation, Tech Debt, Defects, and more.
          You can customize these themes as you build.
        </div>

        <button
          onClick={onStart}
          className="w-full px-6 py-3 bg-[var(--slate)] text-white hover:bg-[var(--slate)] font-medium text-lg transition-colors"
        >
          Start Building Your Pyramid
        </button>
      </div>
    </div>
  );
}


